import loadable from "loadable-components";

const NoBrandPageRoute = loadable(() =>
  import(/* webpackPreload: true, webpackChunkName: "nb" */ "../NoBrandPage")
);

export default NoBrandPageRoute;
